import {AbstractNavigatorBarController} from "./AbstractNavigatorBarController";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";
import {Injectable} from "@angular/core";

@Injectable()
export class NavigatorBarController extends AbstractNavigatorBarController {

  constructor(controllerEventBus: ControllerEventBus) {
    super(controllerEventBus);
  }
}
